<script>
  import BaseRemoteSelect from './base-remote-select';

  export default {
    extends: BaseRemoteSelect,

    computed: {
      /**
       * @return {object|null}
       */
      contactList() {
        return _.get(this.model, 'contact_list', null);
      },
    },

    methods: {
      /**
       * @param {string} search
       * @return {object}
       */
      getQueryParams(search) {
        return _.pickBy({search, brand_id: this.brandId, limit: 10});
      },

      /**
       * @param {Object} item
       * @return {string}
       */
      format(item) {
        return _.get(item, 'name', '-');
      },
    },

    mounted() {
      if (this.brandId && this.contactList) {
        this.options = [{...this.contactList}];
        this.search('');
      }
    },
  }
</script>
